// extracted by mini-css-extract-plugin
export default {"wrapper":"App_wrapper__WnIkY","wrapper-footer":"App_wrapper-footer__eQge-","bodyWrapper":"App_bodyWrapper__DhTat","authenticator":"App_authenticator__XyMxk"};